/* flow */
import React, { Component } from 'react'
import Tooltip from 'antd/lib/tooltip'
import { appClass } from './globals'
import type {ActiveFilters, Initial, Lang} from './App'
import labels from './labels'

type Props = {
  funds: Array<string>,
  urlTemplate: string,
  activeFilters: ActiveFilters,
  lang: Lang,
  initial: Initial,
  dateRange: ?DateRange
}

type State = {
  copied: boolean
}

export default class Dashboard extends Component<Props, State> {
  state = {
    copied: false
  }
  copyLink = (e: SyntheticEvent<HTMLButtonElement>) => {
    const { urlTemplate, activeFilters, funds, initial, dateRange } = this.props
    const {id = null, product = '', owu = '', appendix = '' } = initial || {}
    const adjustedDateRange = dateRange.map(d => {
      const adjustedDate = new Date(d.getTime())
      adjustedDate.setDate(d.getDate() + 1)
      return adjustedDate
    })
    const encoded = encodeURIComponent(JSON.stringify({ initial: { activeFilters, funds, id, product, owu, appendix, 'dateRange': adjustedDateRange } }))
    const input = document.createElement('input')
    input.value = urlTemplate.replace('%acparams%', encoded)
    input.style = 'position: absolute; z-index: -3;'
    document.querySelector(`.${appClass}`).appendChild(input)
    input.select()
    document.execCommand('Copy')
    input.remove()
    this.setState({ copied: true })
    setTimeout(() => {
      this.setState({ copied: false })
    }, 1000)
  }
  render () {
    const { lang } = this.props
    const { copied } = this.state
    const popup = labels[lang][copied ? 'copiedLinkPop' : 'copyLinkPop']
    return (
      <Tooltip title={popup}>
        <button
          className="ui icon left labeled button"
          onClick={this.copyLink}>
          <i aria-hidden="true" className="linkify icon"  style={{color: "#EB1E82"}}></i>{labels[lang].copyLink}
        </button>
      </Tooltip>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Dashboard.js